import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

// Owner-only: issue the Zoho "Call with Nauticus" token. Shown once; paste it into the Zoho Connection.
export function ZohoCallTokenCard() {
  const [email, setEmail] = useState("");
  const [tok, setTok] = useState(null);
  const [busy, setBusy] = useState(false);
  const issue = async () => {
    setBusy(true);
    try { const { data } = await api.post("/integrations/zoho/token", { zoho_user_email: email }); setTok(data.token); }
    catch (e) { toast.error(e?.response?.data?.detail || "Couldn't issue a token."); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border-2 border-[#E5E5E0] bg-white p-5" data-testid="settings-zoho-call">
      <h2 className="text-lg font-bold text-[#0B192C] mb-1">Zoho “Call with Nauticus”</h2>
      <p className="text-sm text-[#6B7280] mb-3">Links your Zoho user to your Nauticus line. Issuing a new token revokes the old one.</p>
      <div className="flex flex-wrap gap-2">
        <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your Zoho login email" className="h-10 w-72" data-testid="zoho-email-input" />
        <Button onClick={issue} disabled={busy || !email} data-testid="zoho-issue-token">Issue token</Button>
      </div>
      {tok && (
        <div className="mt-3 rounded-md bg-[#FFF7ED] p-3 text-sm" data-testid="zoho-token-once">
          <p className="font-semibold text-[#9A3412]">Copy now — it won't be shown again. Paste it only into the Zoho Connection.</p>
          <code className="break-all text-xs">{tok}</code>
        </div>
      )}
    </div>
  );
}
